module.exports = __webpack_public_path__ + "static/featured-shoe-sm-a8734f547a6f0ea89d2e3fbc5f311d13.png";